import { Check, ArrowUpRight } from "lucide-react";
import { MaskedLine, FadeIn } from "@/components/Reveal";
import { BUYER_FORM_URL } from "@/constants/links";

const perks = [
  "Priority access the moment doors open",
  "First look at curated launch collections",
  "Launch updates — considered, never spam",
];

export default function BuyerWaitlist() {
  return (
    <section data-testid="buyer-waitlist-page" className="relative overflow-hidden pb-24 pt-32 sm:pt-40 lg:pt-48">
      <div className="pointer-events-none absolute -top-24 left-[-8%] h-[26rem] w-[26rem] rounded-full bg-[#1E3A8A]/10 blur-[110px]" aria-hidden="true" />
      <div className="relative mx-auto grid max-w-7xl grid-cols-1 gap-16 px-4 sm:px-8 lg:grid-cols-2 lg:gap-20 lg:px-16">
        <div>
          <p className="eyebrow" data-testid="buyer-waitlist-eyebrow">Early Access · Buyers</p>
          <h1 className="mt-8 font-sans text-4xl font-bold leading-[1.08] tracking-tight text-[#0F172A] sm:text-5xl lg:text-6xl">
            <MaskedLine delay={0.15}>Be first</MaskedLine>
            <MaskedLine delay={0.3} className="text-gold-gradient">through the doors.</MaskedLine>
          </h1>
          <FadeIn delay={0.55}>
            <p className="mt-8 max-w-lg text-base leading-relaxed text-[#64748B] sm:text-lg">
              Aflimart Digital Market is in pre-launch. Join the buyer waitlist and reserve your place
              at the front of the queue for a world of curated fashion, technology, luxury and craft.
            </p>
            <ul className="mt-10 space-y-4">
              {perks.map((p, i) => (
                <FadeIn key={p} delay={0.1 * i}>
                  <li data-testid={`buyer-perk-${i + 1}`} className="flex items-start gap-3 text-sm text-[#475569] sm:text-base">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-[#1E3A8A]/50">
                      <Check size={11} className="text-[#1E3A8A]" />
                    </span>
                    {p}
                  </li>
                </FadeIn>
              ))}
            </ul>
          </FadeIn>
        </div>

        <FadeIn delay={0.35}>
          <div
            data-testid="buyer-waitlist-form"
            className="card-dark p-8 sm:p-10 hover:transform-none"
          >
            <h2 className="font-sans text-2xl text-[#0F172A]">Reserve your access</h2>
            <p className="mt-2 text-sm leading-relaxed text-[#94A3B8]">
              Registration is handled through our official buyer waitlist form — it takes less than a minute.
            </p>
            <div className="mt-10">
              <a
                href={BUYER_FORM_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="buyer-waitlist-submit-button"
                className="btn-gold w-full"
              >
                Join the Buyer Waitlist <ArrowUpRight size={16} />
              </a>
              <p data-testid="buyer-form-note" className="mt-6 text-center font-sans text-[10px] leading-relaxed tracking-[0.15em] text-[#CBD5E1]">
                OFFICIAL AFLIMART FORM — OPENS IN A NEW TAB. SUBMISSIONS ARE RECORDED IN OUR GOOGLE TRACKER.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>
  );
}
